var map = {
	"./arrow-bold-down.svg": [
		796,
		56
	],
	"./arrow-bold-left.svg": [
		797,
		57
	],
	"./arrow-bold-right.svg": [
		798,
		58
	],
	"./arrow-bold-up.svg": [
		799,
		59
	],
	"./arrow-down.svg": [
		800,
		60
	],
	"./arrow-filter.svg": [
		801,
		61
	],
	"./arrow-play.svg": [
		802,
		62
	],
	"./bank.svg": [
		803,
		63
	],
	"./bolt.svg": [
		804,
		64
	],
	"./book.svg": [
		805,
		65
	],
	"./burger.svg": [
		806,
		66
	],
	"./caret-right.svg": [
		807,
		67
	],
	"./check.svg": [
		808,
		68
	],
	"./checkbox-empty.svg": [
		809,
		69
	],
	"./checkbox-filled.svg": [
		810,
		70
	],
	"./checked-box.svg": [
		811,
		71
	],
	"./chevron-down.svg": [
		812,
		72
	],
	"./circle-full-screen.svg": [
		813,
		73
	],
	"./circle-live.svg": [
		814,
		74
	],
	"./circle-pause.svg": [
		815,
		75
	],
	"./circle-play.svg": [
		816,
		76
	],
	"./circle-question.svg": [
		817,
		77
	],
	"./clipboard-alt.svg": [
		818,
		78
	],
	"./closecross.svg": [
		819,
		79
	],
	"./copy.svg": [
		820,
		80
	],
	"./cross.svg": [
		821,
		81
	],
	"./dark-mode.svg": [
		822,
		82
	],
	"./dialpad.svg": [
		823,
		83
	],
	"./discord.svg": [
		824,
		84
	],
	"./document.svg": [
		825,
		85
	],
	"./envelope.svg": [
		826,
		86
	],
	"./ethereum.svg": [
		827,
		87
	],
	"./eye.svg": [
		828,
		88
	],
	"./fire.svg": [
		829,
		89
	],
	"./fullscreen.svg": [
		830,
		90
	],
	"./gear.svg": [
		831,
		91
	],
	"./grid-horizontal.svg": [
		832,
		92
	],
	"./heart.svg": [
		833,
		93
	],
	"./home.svg": [
		834,
		94
	],
	"./info-circle-filled.svg": [
		835,
		95
	],
	"./info-circle.svg": [
		836,
		96
	],
	"./instagram.svg": [
		837,
		97
	],
	"./invoice.svg": [
		838,
		98
	],
	"./live.svg": [
		839,
		99
	],
	"./logo-cross.svg": [
		840,
		100
	],
	"./logo.svg": [
		841,
		101
	],
	"./logout.svg": [
		842,
		102
	],
	"./long-left-arrow.svg": [
		843,
		103
	],
	"./long-right-arrow.svg": [
		844,
		104
	],
	"./medium.svg": [
		845,
		105
	],
	"./metamask.svg": [
		846,
		106
	],
	"./moon.svg": [
		847,
		107
	],
	"./palette.svg": [
		848,
		108
	],
	"./pause.svg": [
		849,
		109
	],
	"./pen.svg": [
		850,
		110
	],
	"./power-button.svg": [
		851,
		111
	],
	"./recipes.svg": [
		852,
		112
	],
	"./refresh.svg": [
		853,
		113
	],
	"./search.svg": [
		854,
		114
	],
	"./settings.svg": [
		855,
		115
	],
	"./share.svg": [
		856,
		116
	],
	"./shopping-bag.svg": [
		857,
		117
	],
	"./star.svg": [
		858,
		118
	],
	"./sun.svg": [
		859,
		119
	],
	"./telegram.svg": [
		860,
		120
	],
	"./twitter.svg": [
		861,
		121
	],
	"./user-filled-circle.svg": [
		862,
		122
	],
	"./user-filled.svg": [
		863,
		123
	],
	"./user.svg": [
		864,
		124
	],
	"./viewers.svg": [
		865,
		125
	],
	"./volume-down.svg": [
		866,
		126
	],
	"./volume-mute.svg": [
		867,
		127
	],
	"./volume-off.svg": [
		868,
		128
	],
	"./volume-up.svg": [
		869,
		129
	],
	"./wallet-solid.svg": [
		870,
		130
	],
	"./wallet.svg": [
		871,
		131
	],
	"./walletconnect.svg": [
		872,
		132
	],
	"./walletlink.svg": [
		873,
		133
	],
	"./xdefi.svg": [
		874,
		134
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 492;
module.exports = webpackAsyncContext;